import { DetalleDte } from "src/app/models/Dte/DetalleDte";
import { DteEmitido } from "src/app/models/Dte/DteEmitido";
import { FacturaExportacion } from "src/app/models/Dte/FacturaExportacion";
import { IDte } from "src/app/models/Dte/IDte";

export function prepararPayloadExportacion(dteOriginal: IDte): DteEmitido {
	// Los métodos de normalización modifican la instancia. Se trabaja sobre una copia
	// para que previsualizar no altere el documento que el usuario sigue editando.
	const facturaExportacion = Object.assign(new FacturaExportacion(), JSON.parse(JSON.stringify(dteOriginal))) as FacturaExportacion;
	facturaExportacion.rewriteDetailsByForeignCurrency();
	if (facturaExportacion.otraMonedaEnt) facturaExportacion.otraMonedaEnt.tipoMoneda = "CLP";
	facturaExportacion.rewriteTotals();

	const payload = facturaExportacion.toDteEmitido();
	payload.receptorEnt = facturaExportacion.receptorEnt;
	payload.dteExportacionEnt = facturaExportacion;
	payload.codigoTipoDte = 110;
	payload.FormaPagoExportacion = facturaExportacion.FormaPagoExportacion;
	return payload;
}

export function prepararPayloadLiquidacion(dte: IDte): IDte {
	dte.documentosLiquidados = [];
	(dte.detalleDte || []).forEach((detalle) => {
		(detalle.relatedDocumentsIds || []).forEach((documentoId) => dte.documentosLiquidados.push(documentoId));
	});
	return dte;
}

export function prepararDetalleCorreccionTexto(textoCorreccion: string): DetalleDte {
	const detalle = new DetalleDte();
	detalle.nombre = "Detalle Corrige texto";
	detalle.descripcion = textoCorreccion;
	detalle.cantidad = 0;
	detalle.precioUnitario = 0;
	detalle.descuento = 0;
	detalle.recargo = 0;
	detalle.total = 0;
	return detalle;
}
